/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';

export const TableHeaderForManufacturer = [
  {
    headerName: ' Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sort: 'asc',
    sortable: true,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
